import React from 'react';
import { TrendingUp, Target, Users, Zap } from 'lucide-react';
import { caseStudyData } from '../../data/mockData';

export const CaseStudy = () => {
  const icons = [TrendingUp, Target, Users, Zap];

  return (
    <section id="case-study" className="py-24 bg-[rgb(26,28,30)] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, rgb(0,250,99) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }} />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 bg-[rgba(0,250,99,0.1)] border border-[rgba(0,250,99,0.3)] rounded-full mb-6">
            <span className="text-[rgb(0,250,99)] text-sm font-medium">Case Study</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {caseStudyData.title}
          </h2>
          <p className="text-xl text-[rgb(218,218,218)] max-w-3xl mx-auto">
            {caseStudyData.subtitle}
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {caseStudyData.metrics.map((metric, index) => {
            const Icon = icons[index];
            return (
              <div
                key={metric.id}
                className="relative bg-[rgb(17,17,19)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 hover:border-[rgb(0,250,99)] group overflow-hidden"
              >
                {/* Top Accent */}
                <div className="absolute top-0 left-0 right-0 h-0.5 bg-[rgb(0,250,99)] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-[rgba(0,250,99,0.1)] flex items-center justify-center mb-6">
                  <Icon size={24} className="text-[rgb(0,250,99)]" />
                </div>

                {/* Value */}
                <div className="text-5xl font-bold text-[rgb(0,250,99)] mb-3">
                  {metric.value}
                </div>

                {/* Label */}
                <div className="text-xl font-semibold text-white mb-4">
                  {metric.label}
                </div>

                {/* Description */}
                <p className="text-[rgb(161,161,170)] text-sm leading-relaxed">
                  {metric.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Image Section */}
        <div className="mt-16 rounded-2xl overflow-hidden border border-[rgba(255,255,255,0.1)] max-w-5xl mx-auto">
          <img
            src="https://images.unsplash.com/photo-1762279389020-eeeb69c25813?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwZ3Jvd3RoJTIwdmlzdWFsaXphdGlvbnxlbnwwfHx8fDE3NzE0Mzg5NzB8MA&ixlib=rb-4.1.0&q=85"
            alt="Digital growth visualization"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>
    </section>
  );
};
